export default __webpack_public_path__ + "static/media/vista-site.b81f6231.png";